import { render, staticRenderFns } from "./AttackFields.vue?vue&type=template&id=3bc68706"
import script from "./AttackFields.vue?vue&type=script&lang=js"
export * from "./AttackFields.vue?vue&type=script&lang=js"
import style0 from "./AttackFields.vue?vue&type=style&index=0&id=3bc68706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports